import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Wallet, CreditCard, Receipt, Globe, Shield, ArrowRight } from 'lucide-react';
const LandingPage = () => {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-1237">
      <Navbar data-id="element-1238" />
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#115800] to-[#289f77] text-white" data-id="element-1239">
        <div className="container mx-auto px-4 py-20 md:py-32" data-id="element-1240">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-1241">
            <div data-id="element-1242">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1243">
                Manage Your Finances Seamlessly with BillVast
              </h1>
              <p className="text-xl mb-8" data-id="element-1244">
                A comprehensive fintech platform for digital wallets,
                multi-currency transactions, bill payments, and secure virtual
                cards.
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1245">
                <Link to="/register" className="px-6 py-3 bg-white text-[#115800] font-medium rounded-md hover:bg-gray-100 text-center" data-id="element-1246">
                  Get Started
                </Link>
                <Link to="#features" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 text-center" data-id="element-1247">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="hidden md:block" data-id="element-1248">
              <img src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" alt="Digital finance illustration" className="w-full h-auto rounded-lg shadow-xl" data-id="element-1249" />
            </div>
          </div>
        </div>
      </section>
      {/* Trusted By Section */}
      <section className="bg-white py-10" data-id="element-1250">
        <div className="container mx-auto px-4" data-id="element-1251">
          <p className="text-center text-gray-600 mb-6" data-id="element-1252">
            Trusted by users across multiple countries
          </p>
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-70" data-id="element-1253">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2560px-Google_2015_logo.svg.png" alt="Google" className="h-8" data-id="element-1254" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/2560px-Amazon_logo.svg.png" alt="Amazon" className="h-8" data-id="element-1255" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/2560px-Netflix_2015_logo.svg.png" alt="Netflix" className="h-8" data-id="element-1256" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/2560px-IBM_logo.svg.png" alt="IBM" className="h-8" data-id="element-1257" />
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section id="features" className="py-16 md:py-24 bg-white" data-id="element-1258">
        <div className="container mx-auto px-4" data-id="element-1259">
          <div className="text-center mb-16" data-id="element-1260">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1261">
              Powerful Financial Features
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1262">
              BillVast offers a comprehensive suite of financial tools to manage
              your money efficiently and securely.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1263">
            {/* Feature 1 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1264">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1265">
                <Wallet className="text-[#115800] w-7 h-7" data-id="element-1266" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1267">Digital Wallet</h3>
              <p className="text-gray-600 mb-4" data-id="element-1268">
                Create and manage digital wallets with multi-currency support
                including ZAR, GBP, USD, GHS, and NGN.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1269">
                <li className="flex items-start" data-id="element-1270">
                  <span className="text-[#289f77] mr-2" data-id="element-1271">✓</span>
                  <span data-id="element-1272">Seamless currency exchange</span>
                </li>
                <li className="flex items-start" data-id="element-1273">
                  <span className="text-[#289f77] mr-2" data-id="element-1274">✓</span>
                  <span data-id="element-1275">Real-time rate updates</span>
                </li>
                <li className="flex items-start" data-id="element-1276">
                  <span className="text-[#289f77] mr-2" data-id="element-1277">✓</span>
                  <span data-id="element-1278">Multiple funding methods</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1279">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1280" />
              </Link>
            </div>
            {/* Feature 2 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1281">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1282">
                <CreditCard className="text-[#115800] w-7 h-7" data-id="element-1283" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1284">Virtual Cards</h3>
              <p className="text-gray-600 mb-4" data-id="element-1285">
                Generate secure virtual cards for online transactions with
                instant management capabilities.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1286">
                <li className="flex items-start" data-id="element-1287">
                  <span className="text-[#289f77] mr-2" data-id="element-1288">✓</span>
                  <span data-id="element-1289">USD virtual cards</span>
                </li>
                <li className="flex items-start" data-id="element-1290">
                  <span className="text-[#289f77] mr-2" data-id="element-1291">✓</span>
                  <span data-id="element-1292">Instant locking and disabling</span>
                </li>
                <li className="flex items-start" data-id="element-1293">
                  <span className="text-[#289f77] mr-2" data-id="element-1294">✓</span>
                  <span data-id="element-1295">Secure payment networks</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1296">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1297" />
              </Link>
            </div>
            {/* Feature 3 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1298">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1299">
                <Receipt className="text-[#115800] w-7 h-7" data-id="element-1300" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1301">Bill Payments</h3>
              <p className="text-gray-600 mb-4" data-id="element-1302">
                Pay for various services including airtime recharge, data
                top-up, and TV cable subscriptions.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1303">
                <li className="flex items-start" data-id="element-1304">
                  <span className="text-[#289f77] mr-2" data-id="element-1305">✓</span>
                  <span data-id="element-1306">Quick and secure transactions</span>
                </li>
                <li className="flex items-start" data-id="element-1307">
                  <span className="text-[#289f77] mr-2" data-id="element-1308">✓</span>
                  <span data-id="element-1309">Integration with major services</span>
                </li>
                <li className="flex items-start" data-id="element-1310">
                  <span className="text-[#289f77] mr-2" data-id="element-1311">✓</span>
                  <span data-id="element-1312">Detailed transaction history</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1313">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1314" />
              </Link>
            </div>
            {/* Feature 4 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1315">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1316">
                <Globe className="text-[#115800] w-7 h-7" data-id="element-1317" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1318">
                Multi-Currency Support
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1319">
                Hold and convert funds between different supported currencies
                with competitive exchange rates.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1320">
                <li className="flex items-start" data-id="element-1321">
                  <span className="text-[#289f77] mr-2" data-id="element-1322">✓</span>
                  <span data-id="element-1323">Support for ZAR, GBP, USD, GHS, NGN</span>
                </li>
                <li className="flex items-start" data-id="element-1324">
                  <span className="text-[#289f77] mr-2" data-id="element-1325">✓</span>
                  <span data-id="element-1326">Real-time currency conversion</span>
                </li>
                <li className="flex items-start" data-id="element-1327">
                  <span className="text-[#289f77] mr-2" data-id="element-1328">✓</span>
                  <span data-id="element-1329">Competitive exchange rates</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1330">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1331" />
              </Link>
            </div>
            {/* Feature 5 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1332">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1333">
                <Shield className="text-[#115800] w-7 h-7" data-id="element-1334" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1335">
                Security & Compliance
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1336">
                Advanced security measures including KYC/AML compliance and
                two-factor authentication.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1337">
                <li className="flex items-start" data-id="element-1338">
                  <span className="text-[#289f77] mr-2" data-id="element-1339">✓</span>
                  <span data-id="element-1340">KYC & AML compliance</span>
                </li>
                <li className="flex items-start" data-id="element-1341">
                  <span className="text-[#289f77] mr-2" data-id="element-1342">✓</span>
                  <span data-id="element-1343">Two-factor authentication (2FA)</span>
                </li>
                <li className="flex items-start" data-id="element-1344">
                  <span className="text-[#289f77] mr-2" data-id="element-1345">✓</span>
                  <span data-id="element-1346">Real-time fraud detection</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1347">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1348" />
              </Link>
            </div>
            {/* Feature 6 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1349">
              <div className="bg-[#03e8b1]/20 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6" data-id="element-1350">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="text-[#115800] w-7 h-7" data-id="element-1351">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" data-id="element-1352" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1353">
                Transaction Monitoring
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1354">
                Comprehensive transaction history and monitoring with detailed
                records for tracking payments.
              </p>
              <ul className="space-y-2 mb-4" data-id="element-1355">
                <li className="flex items-start" data-id="element-1356">
                  <span className="text-[#289f77] mr-2" data-id="element-1357">✓</span>
                  <span data-id="element-1358">Real-time transaction updates</span>
                </li>
                <li className="flex items-start" data-id="element-1359">
                  <span className="text-[#289f77] mr-2" data-id="element-1360">✓</span>
                  <span data-id="element-1361">Detailed payment records</span>
                </li>
                <li className="flex items-start" data-id="element-1362">
                  <span className="text-[#289f77] mr-2" data-id="element-1363">✓</span>
                  <span data-id="element-1364">Exportable statements</span>
                </li>
              </ul>
              <Link to="#" className="text-[#289f77] font-medium flex items-center hover:text-[#115800]" data-id="element-1365">
                Learn more <ArrowRight className="ml-1 w-4 h-4" data-id="element-1366" />
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-gray-50" data-id="element-1367">
        <div className="container mx-auto px-4" data-id="element-1368">
          <div className="text-center mb-16" data-id="element-1369">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1370">
              How BillVast Works
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1371">
              Get started with BillVast in just a few simple steps
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1372">
            {/* Step 1 */}
            <div className="text-center" data-id="element-1373">
              <div className="bg-[#289f77] text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold" data-id="element-1374">
                1
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1375">Create an Account</h3>
              <p className="text-gray-600" data-id="element-1376">
                Sign up for a BillVast account with your email and complete the
                simple verification process.
              </p>
            </div>
            {/* Step 2 */}
            <div className="text-center" data-id="element-1377">
              <div className="bg-[#289f77] text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold" data-id="element-1378">
                2
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1379">Fund Your Wallet</h3>
              <p className="text-gray-600" data-id="element-1380">
                Add funds to your digital wallet using bank transfers or card
                payments in your preferred currency.
              </p>
            </div>
            {/* Step 3 */}
            <div className="text-center" data-id="element-1381">
              <div className="bg-[#289f77] text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold" data-id="element-1382">
                3
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-1383">Start Transacting</h3>
              <p className="text-gray-600" data-id="element-1384">
                Pay bills, create virtual cards, and manage your finances across
                multiple currencies with ease.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-1385">
            <Link to="/register" className="px-6 py-3 bg-[#289f77] text-white font-medium rounded-md hover:bg-[#115800] inline-block" data-id="element-1386">
              Get Started Now
            </Link>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16 md:py-24 bg-white" data-id="element-1387">
        <div className="container mx-auto px-4" data-id="element-1388">
          <div className="text-center mb-16" data-id="element-1389">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1390">
              What Our Users Say
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1391">
              Hear from people who have transformed their financial management
              with BillVast
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1392">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100" data-id="element-1393">
              <div className="flex items-center mb-4" data-id="element-1394">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80" alt="Sarah J." className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1395" />
                <div data-id="element-1396">
                  <h4 className="font-semibold" data-id="element-1397">Sarah J.</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1398">Business Owner</p>
                </div>
              </div>
              <div className="flex mb-4 text-yellow-400" data-id="element-1399">
                {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-1400">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1401" />
                  </svg>)}
              </div>
              <p className="text-gray-700" data-id="element-1402">
                "BillVast has revolutionized how I manage my business finances.
                The multi-currency feature saves me time and money when dealing
                with international clients."
              </p>
            </div>
            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100" data-id="element-1403">
              <div className="flex items-center mb-4" data-id="element-1404">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80" alt="Michael T." className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1405" />
                <div data-id="element-1406">
                  <h4 className="font-semibold" data-id="element-1407">Michael T.</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1408">Digital Nomad</p>
                </div>
              </div>
              <div className="flex mb-4 text-yellow-400" data-id="element-1409">
                {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-1410">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1411" />
                  </svg>)}
              </div>
              <p className="text-gray-700" data-id="element-1412">
                "The virtual card feature is a game-changer for me. I can create
                secure cards for different services and manage them all from one
                place. Highly recommended!"
              </p>
            </div>
            {/* Testimonial 3 */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-100" data-id="element-1413">
              <div className="flex items-center mb-4" data-id="element-1414">
                <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80" alt="Priya K." className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1415" />
                <div data-id="element-1416">
                  <h4 className="font-semibold" data-id="element-1417">Priya K.</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1418">Student</p>
                </div>
              </div>
              <div className="flex mb-4 text-yellow-400" data-id="element-1419">
                {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-1420">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1421" />
                  </svg>)}
              </div>
              <p className="text-gray-700" data-id="element-1422">
                "As a student studying abroad, BillVast has made managing my
                finances so much easier. The bill payment feature helps me stay
                on top of my expenses without any hassle."
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section id="contact" className="py-16 bg-[#289f77] text-white" data-id="element-1423">
        <div className="container mx-auto px-4 text-center" data-id="element-1424">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1425">
            Ready to Transform Your Financial Experience?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto" data-id="element-1426">
            Join thousands of users who are already enjoying the benefits of
            BillVast's comprehensive financial platform.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1427">
            <Link to="/register" className="px-6 py-3 bg-white text-[#115800] font-medium rounded-md hover:bg-gray-100 text-center" data-id="element-1428">
              Create Account
            </Link>
            <Link to="#" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 text-center" data-id="element-1429">
              Contact Sales
            </Link>
          </div>
        </div>
      </section>
      <Footer data-id="element-1430" />
    </div>;
};
export default LandingPage;